document.addEventListener('DOMContentLoaded', function() {
  setupAddToCartButtons();
  setupCrossSellQuickAddToggle();
  setupQuickAddButtons();
});

window.onload = function() {
  setupAddToCartButtons();
  setupCrossSellQuickAddToggle();
  setupQuickAddButtons();
};

function setupAddToCartButtons() {
    document.querySelectorAll('.variant-button').forEach(function(button) {
    // console.log("i am calling");
    button.addEventListener('click', function() {
      // Retrieve the hidden input with the variant ID within the same form
      var form = this.closest('form');
      var variantIdInput = form.querySelector('input[name="id"]');
      var variantId = variantIdInput.value;

      if (variantId) {
        addToCart(variantId);
      } else {
        alert('Variant ID is missing');
      }
    });
  });
}

function setupCrossSellQuickAddToggle() {
  if (document.body.dataset.crossSellQuickAddToggleReady === 'true') {
    return;
  }

  document.body.dataset.crossSellQuickAddToggleReady = 'true';

  document.addEventListener('click', function(event) {
    var quickAddButton = event.target.closest('cc-cart-cross-sell .cc-cross-sell-quick-add');
    if (!quickAddButton) {
      return;
    }

    event.preventDefault();

    var singleVariantId = quickAddButton.getAttribute('data-variant-id');
    if (quickAddButton.classList.contains('btn-quickadd') && singleVariantId) {
      addItem(singleVariantId);
      return;
    }

    var quickAddWrap = quickAddButton.closest('.cc-cross-sell-quick-add-wrap');
    var variantsPanel = quickAddWrap ? quickAddWrap.querySelector('.cc-cross-sell-variants') : null;

    if (!variantsPanel) {
      return;
    }

    var shouldOpen = variantsPanel.hidden;
    variantsPanel.hidden = !shouldOpen;
    quickAddButton.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  });
}

function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then((response) => {
      console.log(response);
      let sec_url = window.location.pathname + "?section_id=cart-drawer";
      fetch(sec_url)
      .then((response) => response.text())
      .then((responseText) => {
        let html = new DOMParser().parseFromString(responseText, "text/html");
         console.log(html);
        $("cart-drawer cart-form").html("");
        
        let box = document.querySelector("cart-drawer cart-form");
        box.insertAdjacentHTML(
          "beforeend",
          html.querySelector("cart-drawer cart-form").innerHTML
        );
        
        $('.cc-popup-close').on('click', function() {
            $(".cart-drawer-modal").removeClass('cc-popup--visible');
            $("body").removeClass("cc-popup-no-scroll cc-popup-no-scroll-pad-right");
        });
        
        let bubble_count = $("cart-drawer .cart-drawer__title-count").data("cart_item") || 0;
        let bubble_html = '<span class="cart-link__count">'+ bubble_count +'</span>';
        let cartIcon = document.querySelector(".cart-link__icon");
        
        if (cartIcon) {
            cartIcon.insertAdjacentHTML("beforeend", bubble_html);
        }
        /*$(".cart-link").click();*/
        if (response.ok) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                bubbles: true
            }));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        }
      });
      return response.json(); 
      // return true;
    })
    .then((data) => {
        if (data.status && data.status === 422) {
            // Handle the error response
            console.error('Error:', data.description);
            alert(data.description); 
        }
    })
    .catch((error) => {
      console.error('There was a problem with the fetch operation:', error);
    });
  }

$(document).ready(function() {
  // open cart-drawer when click on product variant and popup close
  $(document).on('click', '.variant-button',function() {
    $(document).on('click', '#aca-bottom-close',function() {
      document.querySelector('.cart-link').click();
    });
  });

  //Size Chart
  /*var sztabs = $('.size-chart');
  var sztabContent = $('.size-chart-content');
  var sztabNav = $('.size-chart-controls .size-chart-btn');
  
  sztabContent.hide();
  var firstElement = $('.size-chart-controls .size-chart-btn:first').attr('data-target');
  sztabs.find('.'+firstElement).show();        
  
  sztabNav.on('click', function(e){
    e.preventDefault();
    sztabNav.addClass('btn--secondary');
    $(this).removeClass('btn--secondary');
    sztabContent.hide();

    var szactiveTab = $(this).attr('data-target');
    sztabs.find('.'+szactiveTab).fadeIn();        

  })*/

  $('.size-chart-unit-tabs').each(function(){
    var tabs = $(this);
    var tabContent = $(this).find('.size-chart-unit-item');
    var tabNav = $(this).find('.size-chart-unit-controls .size-chart-unit-btn');
    
    tabContent.hide();
    // $(this).find('.tabs-nav li:first').addClass('active');
    $(this).find('.size-chart-unit-item:first').show();
    
      tabNav.on('click', function(e){
        e.preventDefault();
        tabNav.addClass('btn--secondary');
        $(this).removeClass('btn--secondary');
        tabContent.hide();

        var activeTab = $(this).attr('data-target');
        tabs.find(activeTab).fadeIn();        

      })
    
  })
});

// Tabs
  document.querySelectorAll('.tabs').forEach(tabsContainer => {
    const buttons = tabsContainer.querySelectorAll('.tab-btn');
    const contents = tabsContainer.querySelectorAll('.tab-content');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const target = button.dataset.tab;

        // Deactivate all buttons and contents
        buttons.forEach(btn => btn.classList.remove('active'));
        contents.forEach(content => content.classList.remove('active'));

        // Activate selected
        button.classList.add('active');
        tabsContainer.querySelector(`.tab-content[data-tab-id="${target}"]`)?.classList.add('active');
      });
    });
  });

// GWP Add first variant ID on click - NA
function gwpCart() {
    document.querySelectorAll('.cart-item__gift').forEach(cartItem => {
      const variantSelect = cartItem.querySelector('.variant-select');
      const giftButton = cartItem.querySelector('.btn-gift');

      if (cartItem.hasAttribute('data-gwp-initialized')) {
        return;
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', function() {
          const selectedOption = variantSelect.selectedOptions[0];
          const selectedVariantID = selectedOption.getAttribute('value');
          giftButton.setAttribute('data-gift-id', selectedVariantID);
        });
      }

      giftButton.addEventListener('click', function(event) {
        event.preventDefault();
        const variantID = giftButton.getAttribute('data-gift-id');
        addItem(variantID);
      });

      cartItem.setAttribute('data-gwp-initialized', 'true');
    });
}

document.addEventListener('on:cart-drawer:after-open', (event) => {
  gwpCart();
})

gwpCart();

// Javascript function to add variant ID - NA
function addItem(variantID) {
    if (!variantID) {
      return Promise.resolve();
    }

    const cartTemplate = document.querySelector('.template-cart');
    const isCartPage = Boolean(cartTemplate);

    if (!isCartPage) {
      // Open immediately for faster perceived feedback while request runs.
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    }

    return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            quantity: 1,
            id: variantID
        }),
    })
    .then((response) => {
      if (response.ok) {
        if (isCartPage) {
            window.location.reload();
        } else {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                bubbles: true
            }));
        }
      } else {
          console.error('Failed to add item to the cart');
      }
    })
    .catch((error) => console.error(error));
}

function setupQuickAddButtons() {
  if (document.body.dataset.quickAddButtonsReady === 'true') {
    return;
  }

  document.body.dataset.quickAddButtonsReady = 'true';

  document.addEventListener('click', function(event) {
    var variantButton = event.target.closest('.btn-quickadd');
    if (!variantButton) {
      return;
    }

    if (variantButton.closest('cc-cart-cross-sell .cc-cross-sell-quick-add')) {
      // Cross-sell quick add icon is handled by setupCrossSellQuickAddToggle.
      return;
    }

    event.preventDefault();

    if (variantButton.disabled) {
      return;
    }

    var variantID = variantButton.getAttribute('data-variant-id');
    if (!variantID) {
      return;
    }

    addItem(variantID);
  });
}

// Afterpay Shadow dom override
if (window.location.pathname.includes('/products/')) {
  setTimeout(() => {
    const shadowHost = document.querySelector('square-placement');
    if (shadowHost) {
      const shadowRoot = shadowHost.shadowRoot;
      const style = document.createElement('style');
      style.textContent = `
        strong {
          font-weight: 600;
        }
      `;
      shadowRoot.appendChild(style);
    }
  }, 1000);
}


$(document).on('swell:setup', function() {
    // Topbar Yotpo Points Script
    const customerBlock = document.getElementById('customer-header__block');
    
    // Function to set a cookie
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // days in milliseconds
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    // Function to get a cookie value by name
    function getCookie(name) {
        const nameEQ = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookiesArray = decodedCookie.split(';');
        for(let i = 0; i < cookiesArray.length; i++) {
            let cookie = cookiesArray[i].trim();
            if (cookie.indexOf(nameEQ) === 0) {
                return cookie.substring(nameEQ.length, cookie.length);
            }
        }
        return null;
    }

    const hideUntil = getCookie('customerHeaderBlockPoints');
    const currentTime = Date.now();

    // If hideUntil exists and the current time is greater than hideUntil, show the block
    if (!hideUntil || currentTime >= hideUntil) {
        customerBlock.style.display = 'flex';
    }

    // Event listener for the close button
    document.querySelector('.btn-close__yotpo').addEventListener('click', function () {
        customerBlock.style.display = 'none';
        // Set a cookie to hide for 24 hours
        const hideUntilTime = currentTime + 86400000; // 24 hours in milliseconds
        setCookie('customerHeaderBlockPoints', hideUntilTime, 1); // Cookie expires in 1 day
    });

    var customerDetails = swellAPI.getCustomerDetails();
    var customerPointsBalance = customerDetails.pointsBalance;

    $('#earned-points-container').text(customerPointsBalance);

    var discountText = '';
    if (customerPointsBalance >= 100 && customerPointsBalance < 200) {
        discountText = '$10 off at checkout*';
    } else if (customerPointsBalance >= 200 && customerPointsBalance < 300) {
        discountText = 'Up to $20 off at checkout*';
    } else if (customerPointsBalance >= 300 && customerPointsBalance < 400) {
        discountText = 'Up to $30 off at checkout*';
    } else if (customerPointsBalance >= 400 && customerPointsBalance < 500) {
        discountText = 'Up to $40 off at checkout*';
    } else if (customerPointsBalance >= 500) {
        discountText = 'Up to $50 off at checkout*';
    }

    if (customerPointsBalance >= 100) {
        $('.customer-block__discount').text(discountText).show();
        if (!hideUntil || currentTime >= hideUntil) {
            customerBlock.style.display = 'flex';
        }
    } else {
        customerBlock.style.display = 'none';    
    }
});
